function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */
export var Schema =
/**
 * @constructor
 * @param {Properties} property
 * @param {Normal} normal
 * @param {string} [space]
 */
function Schema(property, normal, space) {
  _classCallCheck(this, Schema);

  this.property = property;
  this.normal = normal;

  if (space) {
    this.space = space;
  }
};
/** @type {Properties} */

Schema.prototype.property = {};
/** @type {Normal} */

Schema.prototype.normal = {};
/** @type {string|null} */

Schema.prototype.space = null;